/* KELI — Scroll Reveal
   Install: Assets → add new → name "keli-reveal.js" → paste → Save.
   Add ONE line in theme.liquid, right before </body>:
   {{ 'keli-reveal.js' | asset_url | script_tag }}
   Apply by adding class="keli-reveal" to any element — product cards already have it
   wired in via the grid template; add it to section headings/images elsewhere as desired.
*/
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.keli-reveal').forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.keli-reveal').forEach(function (el) { observer.observe(el); });
})();